module.exports = __webpack_public_path__ + "img/contact2.03ed7f47.png";